import { Text } from '@etg/wings';
import ProductDrawerCard from '../../common/components/ProductDrawerCard';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const LoungeDrawerContent = _ref => {
  var _loungeInfo$amenities, _loungeInfo$condition;
  let {
    drawerText,
    loungeInfo
  } = _ref;
  const {
    openningFrom,
    openningTo,
    oppeningTitle,
    amenities: amenitiesText,
    location,
    condition: conditionText,
    terminal
  } = drawerText;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ProductDrawerCard, {
      cardTitle: oppeningTitle,
      children: /*#__PURE__*/_jsxs(Text, {
        children: [openningFrom, " ", /*#__PURE__*/_jsx(Text, {
          variant: "14-bold",
          children: loungeInfo.openAt
        }), " ", openningTo, ' ', /*#__PURE__*/_jsx(Text, {
          variant: "14-bold",
          children: loungeInfo.closeAt
        })]
      })
    }), /*#__PURE__*/_jsx(ProductDrawerCard, {
      cardTitle: amenitiesText,
      children: /*#__PURE__*/_jsx("ul", {
        children: (_loungeInfo$amenities = loungeInfo.amenities) === null || _loungeInfo$amenities === void 0 ? void 0 : _loungeInfo$amenities.map((amenity, index) => /*#__PURE__*/_jsx("li", {
          children: amenity === null || amenity === void 0 ? void 0 : amenity.name
        }, index))
      })
    }), /*#__PURE__*/_jsx(ProductDrawerCard, {
      cardTitle: location,
      children: /*#__PURE__*/_jsx(Text, {
        children: `${terminal} ${loungeInfo.terminal}`
      })
    }), /*#__PURE__*/_jsx(ProductDrawerCard, {
      cardTitle: conditionText,
      children: (_loungeInfo$condition = loungeInfo.conditions) === null || _loungeInfo$condition === void 0 ? void 0 : _loungeInfo$condition.map((condition, index) => /*#__PURE__*/_jsx(Text, {
        children: condition === null || condition === void 0 ? void 0 : condition.description
      }, index))
    })]
  });
};
export default LoungeDrawerContent;
//# sourceMappingURL=LoungeDrawerContent.js.map